import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { CheckCircle, AlertCircle, Loader2 } from 'lucide-react';
import './CustomerAuth.css';

export default function VerifyEmail() {
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const token = params.get('token');
  const store = params.get('store') || '';

  const [status, setStatus] = useState(token ? 'verifying' : 'missing');
  const [message, setMessage] = useState('');
  const [errorCode, setErrorCode] = useState('');

  useEffect(() => {
    if (!token) return;

    let cancelled = false;

    (async () => {
      try {
        const url = `/api/customer/auth/verify-email?token=${encodeURIComponent(token)}&store=${encodeURIComponent(store)}`;
        const response = await fetch(url, {
          method: 'GET',
          credentials: 'include'
        });
        const data = await response.json().catch(() => ({}));

        if (cancelled) return;

        if (response.ok && data.success !== false) {
          setStatus('success');
          setMessage(data.message || 'Your email has been verified.');
        } else {
          setStatus('error');
          setErrorCode(data.code || '');
          setMessage(data.error || 'We could not verify your email.');
        }
      } catch (err) {
        if (cancelled) return;
        setStatus('error');
        setMessage('Unable to reach the server. Please try again.');
      }
    })();

    return () => { cancelled = true; };
  }, [token, store]);

  const goToLogin = () => {
    const next = store ? `/login?store=${encodeURIComponent(store)}` : '/login';
    navigate(next);
  };

  return (
    <div className="customer-auth">
      <div className="auth-container">
        <div className="auth-header">
          <h1>Email verification</h1>
        </div>

        {status === 'verifying' && (
          <div className="alert" style={{ background: 'var(--c-surface-2)', color: 'var(--c-text-muted)', border: '1px solid var(--c-line)' }}>
            <Loader2 size={16} style={{ animation: 'c-spin 0.8s linear infinite' }} aria-hidden />
            <span>Verifying your email…</span>
          </div>
        )}

        {status === 'missing' && (
          <div className="alert-error" role="alert">
            <AlertCircle size={16} aria-hidden />
            <span>This link is missing a verification token. Please use the link from your email.</span>
          </div>
        )}

        {status === 'success' && (
          <>
            <div className="alert-success" role="status">
              <CheckCircle size={16} aria-hidden />
              <span>{message}</span>
            </div>
            <button type="button" className="btn-primary" onClick={goToLogin}>
              Continue to sign in
            </button>
          </>
        )}

        {status === 'error' && (
          <>
            <div className="alert-error" role="alert">
              <AlertCircle size={16} aria-hidden />
              <span>{message}</span>
            </div>
            <button type="button" className="btn-primary" onClick={goToLogin}>
              {errorCode === 'TOKEN_EXPIRED' ? 'Sign in to resend' : 'Back to sign in'}
            </button>
          </>
        )}
      </div>
    </div>
  );
}
